// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zagLcLRmyZS9HS {
  height: 100%;
}
.v4Sfr5E_H_HtLR,
.hgBh5RDfkLP4h1 {
  position: relative;
  height: 100%;
}
.hgBh5RDfkLP4h1 {
  border-radius: var(--ds-border-radius-400, 16px);
}
.hgBh5RDfkLP4h1.aAJ_FYz0MXv47j {
  border-radius: unset;
}
.n80e5b1uQjSot9 {
  display: flex;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: var(--ds-space-050, 4px) var(--ds-space-200, 16px) var(--ds-space-400, 32px);
  background: var(--ds-surface, #ffffff);
}
.n80e5b1uQjSot9.f5Yp4dkBmTpjUz {
  transition: padding 0.2s ease-in-out;
}
.n80e5b1uQjSot9.ZnRkJ7zzhnXu0v {
  bottom: var(--ds-space-800, 64px);
}
.n80e5b1uQjSot9.aAJ_FYz0MXv47j {
  padding: var(--ds-space-0, 0);
}
@media print {
  .n80e5b1uQjSot9 {
    flex-direction: column;
  }
}
`, ""]);
// Exports
export var manager = `zagLcLRmyZS9HS`;
export var content = `v4Sfr5E_H_HtLR`;
export var inboxContent = `hgBh5RDfkLP4h1`;
export var single = `aAJ_FYz0MXv47j`;
export var splitscreen = `n80e5b1uQjSot9`;
export var animate = `f5Yp4dkBmTpjUz`;
export var tabs = `ZnRkJ7zzhnXu0v`;
export default ___CSS_LOADER_EXPORT___;
